import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import SkeletonCard from "./SkeletonCard";
import { useAuth } from "../context/AuthContext";
import { getUser } from "../services/api";

export default function ProtectedSuperRoute({ children }) {
  const { user, login: setUser, logout } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getUserData = async () => {
      try {
        const response = await getUser();
        setUser(response);
      } catch {
        logout();
      } finally {
        setLoading(false);
      }
    };

    getUserData();
  }, []);

  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-4 sm:gap-x-6 md:gap-x-4 gap-y-3 sm:gap-y-4 md:gap-y-5">
        {Array(6)
          .fill(0)
          .map((_, i) => (
            <SkeletonCard key={i} />
          ))}
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

 // role → route mapping
    const roleRoutes = {
    CUSTOMER: "/dashboard",
    ADMIN: "/admindashboard",
    AGENT: "/agentdashboard",
    };

    // redirect non-admin users
    if (user.role !== "SUPER_ADMIN") {
    return <Navigate to={roleRoutes[user.role] || "/login"} />;
    }

  return children;
}
